import {
    DropdownInlineEditor,
    DropdownInlineEditorProps,
} from 'components/inline_edit/DropdownInlineEditor';

export type ProfileDropdownOption<TValue extends string> = {
    Value: TValue;
    Text: string;
};

export type ProfileSettingDropdownInlineEditorProps<TValue extends string> = Omit<
    DropdownInlineEditorProps<ProfileDropdownOption<TValue>>,
    'dropdownConfig' | 'renderValue'
>;

export function ProfileSettingDropdownInlineEditor<TValue extends string>(
    props: ProfileSettingDropdownInlineEditorProps<TValue>
) {
    return (
        <DropdownInlineEditor
            renderValue={(value) => value?.Text}
            dropdownConfig={{
                renderLabel: ({ value }) => value?.Text,
                renderItem: ({ item }) => item.Text,
                dataKey: (item) => item.Value,
            }}
            {...props}
        />
    );
}
